import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
}

export const getListMember = async (search?: string, filter?: Filter, page?: number) => {
  let url = `${API_URLS}/members?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter?.type) url += `filters${filter.field}=${filter.type}`
  try {
    let response = await axios.get(url)
    //change isSobatSehat from true false to sobat sehat, self care club
    response.data.data = response.data?.data?.map((e: any) => {
      if (e.attributes.isSobatSehat) {
        e.attributes.isSobatSehat = 'Sobat Sehat'
      } else {
        e.attributes.isSobatSehat = 'Self Care Club'
      }
      return e
    })

    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListMemberByCycleId = async (
  cycleId: string,
  search?: string,
  filter?: string,
  page?: number
) => {
  let url = `${API_URLS}/members?filters[ongoing_cycle][id][$eq]=${cycleId}&populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter) url += `filters[type][$eq]=${filter}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListMemberCycleByMemberId = async (memberId: string) => {
  let url = `${API_URLS}/member-cycles?populate=*&filters[member][id][$eq]=${memberId}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListMemberCycleDetail = async (memberId: string) => {
  let url = `${API_URLS}/member-cycles?populate[member][populate][0]=self_care_activity_histories&populate=cycle&filters[member][id][$eq]=${memberId}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListMemberCycle = async (cycleId: string) => {
  let url = `${API_URLS}/member-cycles?populate=*&filters[cycle][id][$eq]=${cycleId}&filters[member][id][$gt]=0&filters[status]=ongoing`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailMember = async (id: any, search?: string, filter?: string, page?: number) => {
  let url = `${API_URLS}/member-details?populate=*&filters[member][id]=${id}&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter) url += `filters[status][$eq]=${filter}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getMemberById = async (id: any) => {
  try {
    const response = await axios.get(
      `${API_URLS}/members/${id}?populate[passed_cycles][populate][0]=activities&populate[ongoing_cycle][populate][0]=activities&populate[self_care_activity_histories][populate][0]=self_care_activity&populate[cycles][populate][0]=cycle&populate=persona&populate[transactions][populate][0]=transactions`
    )
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postMember = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/members`, {data: datas})
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postImportMember = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/members/import`, datas)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putMember = async (datas: any) => {
  try {
    const response = await axios.put(`${API_URLS}/members/${datas.id}`, {data: datas})
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postFreeze = async (datas: any) => {
  try {
    const response = await axios.put(
      `${API_URLS}/members/${
        datas.status === 'freeze' || datas.status === 'unfreezed' ? 'freeze' : 'deactivate'
      }`,
      {data: datas}
    )
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postDeactive = async (datas: any) => {
  try {
    const response = await axios.post(`${API_URLS}/members/deactivate`, {data: datas})
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteMember = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/members/${id}`)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getAllListMember = async () => {
  let url = `${API_URLS}/members?populate=*`
  try {
    const response = await axios.get(url)
    const allMembers = response.data.data.map((e: any) => ({
      label: e.attributes.fullname,
      value: e.id,
    }))
    return Promise.resolve(allMembers)
  } catch (error) {
    return Promise.reject(error)
  }
}
